/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load LinkedIn premium functions
 * */

(function (pmw, $, undefined) {

	pmw.load_linkedin_pixel = () => {

		try {
			// @formatter:off

			_linkedin_partner_id = pmwDataLayer.pixels.linkedin.partner_id;
			window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
			window._linkedin_data_partner_ids.push(_linkedin_partner_id);

			(function(l) {
			if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
			window.lintrk.q=[]}
			var s = document.getElementsByTagName("script")[0];
			var b = document.createElement("script");
			b.type = "text/javascript";b.async = true;
			b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
			s.parentNode.insertBefore(b, s);})(window.lintrk);

			// @formatter:on

			pmwDataLayer.pixels.linkedin.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	/**
	 * Check if the LinkedIn Pixel can be fired
	 *
	 * @return {boolean}
	 */
	pmw.canFireLintrk = () => {

		if (!pmwDataLayer?.pixels?.linkedin?.loaded) return false

		// If the user has not given consent for marketing, return false
		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if the LinkedIn Pixel can NOT be fired
	 * 
	 * @return {boolean}
	 */
	pmw.canNotFireLinktrk = () => {
		return !pmw.canFireLintrk()
	}

}(window.pmw = window.pmw || {}, jQuery));
